import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Login } from "./components/signin-up/login";
import { Settings } from "./components/settings/settings";
import { Homepage } from "./components/home/homepage";
import { PageNotFound } from "./components/pageNotFound";
import { Signup } from "./components/signin-up/signup";
import { ResetPassword } from "./components/signin-up/ResetPassword";
import { VerifyEmail } from "./components/signin-up/verifyEmail";
import { Lists } from "./components/lists";
import { EditList } from "./components/edit-list";
import { Dashboard } from "./components/dashboard";
import { Family } from "./components/family";
import { TaskManagmentPage } from "./components/taskManagmentPage";

export const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signin" element={<Login />} />
        <Route path="/verify/:token" element={<VerifyEmail />} />
        <Route path="/resetpassword/:token" element={<ResetPassword />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/lists" element={<Lists />} />
        <Route path="/dashboard/lists/:id" element={<EditList />} />
        <Route path="/dashboard/family" element={<Family />} />
        <Route path="/dashboard/family/messages" element={<EditList />} />
        <Route
          path="/dashboard/family/taskmanagment"
          element={<TaskManagmentPage />}
        />
        <Route path="/settings" element={<Settings />} />
        <Route path="/:path" element={<PageNotFound />} />
      </Routes>
    </Router>
  );
};
